var _style, _g;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLtoeUpdatePreferencesIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 64.9 57.2",
    style: {
      enableBackground: "new 0 0 64.9 57.2"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#E5F1FA;}\n\t.st1{fill:#BFDDF1;}\n\t.st2{fill:#2A3953;}\n\t.st3{fill:#7FBAE3;}\n\t.st4{fill:#FFD392;}\n\t.st5{fill:#FFFFFF;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_2171",
    transform: "translate(-3166.51 -13062.893)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2149",
    transform: "translate(3167.731 13075.532)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_1471",
    className: "st0",
    d: "M4.2,0h54c2.2,0,3.9,1.7,3.9,3.9v35.5c0,2.2-1.7,3.9-3.9,3.9h-54c-2.2,0-3.9-1.7-3.9-3.9 V3.9C0.3,1.7,2.1,0,4.2,0z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_2150",
    transform: "translate(3222.851 13075.532)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1417",
    className: "st1",
    d: "M3.3,0h-3v43.3h3c2,0,3.7-1.7,3.7-3.7V3.7C7,1.7,5.4,0,3.3,0z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_2151",
    transform: "translate(3166.51 13074.312)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1418",
    className: "st2",
    d: "M59.7,45.8H5.3c-2.7,0-4.9-2.2-4.9-4.9v-36C0.3,2.2,2.5,0,5.3,0h54.4c2.7,0,4.9,2.2,4.9,4.9 v35.9C64.6,43.5,62.4,45.8,59.7,45.8z M5.3,2.4c-1.4,0-2.5,1.1-2.5,2.5v35.9c0,1.4,1.1,2.5,2.5,2.5h54.4c1.4,0,2.5-1.1,2.5-2.5 V4.9c0-1.4-1.1-2.5-2.5-2.5H5.3z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_2166",
    transform: "translate(3173.216 13081.771)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2161",
    transform: "translate(0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2152",
    transform: "translate(1.221 1.221)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1472",
    x: 0.3,
    y: 0,
    className: "st3",
    width: 22.4,
    height: 28.4
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_2159",
    transform: "translate(0 2.84)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2153",
    transform: "translate(1.221 16.913)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_1473",
    className: "st4",
    d: "M5.3,0h12.4c2.8,0,5,2.2,5,5v4.9l0,0H0.3l0,0V5C0.3,2.2,2.6,0,5.3,0z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_2154",
    transform: "translate(0 15.692)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1419",
    className: "st2",
    d: "M23.9,12.3H1.5c-0.7,0-1.2-0.5-1.2-1.2V5c0-2.8,2.2-5,5-5h14.8c2.8,0,5,2.2,5,5v6.1 C25.1,11.8,24.6,12.3,23.9,12.3z M2.8,9.9h19.9V5c0-1.4-1.2-2.6-2.6-2.6H5.3C3.9,2.4,2.8,3.6,2.8,5V9.9z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_2155",
    transform: "translate(9.437 13.006)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_1474",
    className: "st1",
    d: "M0.3,0h5.9l0,0v5.3c0,1.6-1.3,3-3,3l0,0l0,0c-1.6,0-3-1.3-3-3l0,0L0.3,0L0.3,0z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_2156",
    transform: "translate(8.216 11.785)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1420",
    className: "st2",
    d: "M4.5,10.7c-2.3,0-4.2-1.9-4.2-4.2V1.2C0.3,0.5,0.9,0,1.5,0h5.9c0.7,0,1.2,0.5,1.2,1.2v5.3 C8.7,8.8,6.8,10.7,4.5,10.7z M2.8,2.4v4.1c0,1,0.8,1.8,1.8,1.8s1.8-0.8,1.8-1.8l0,0V2.4H2.8z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_2157",
    transform: "translate(6.468 1.221)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_1475",
    className: "st5",
    d: "M6.3,0L6.3,0c3.3,0,5.9,2.7,5.9,5.9v3c0,3.3-2.7,5.9-5.9,5.9l0,0 c-3.3,0.1-6-2.5-6-5.8V6C0.3,2.7,3,0,6.3,0z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_2158",
    transform: "translate(5.247)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1421",
    className: "st2",
    d: "M7.5,17.4c-4,0-7.2-3.2-7.2-7.2v-3c0-4,3.2-7.2,7.2-7.2s7.2,3.2,7.2,7.2v3 C14.6,14.2,11.4,17.4,7.5,17.4z M7.5,2.4c-2.6,0-4.7,2.1-4.7,4.7v3c0,2.6,2.1,4.7,4.7,4.7s4.7-2.1,4.7-4.7l0,0v-3 C12.2,4.6,10.1,2.4,7.5,2.4z"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_2160"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1422",
    className: "st2",
    d: "M23.9,30.8H1.5c-0.7,0-1.2-0.5-1.2-1.2V1.2C0.3,0.5,0.9,0,1.5,0h22.4c0.7,0,1.2,0.5,1.2,1.2 v28.4C25.1,30.3,24.6,30.8,23.9,30.8z M2.8,28.4h19.9v-26H2.8V28.4z"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_2162",
    transform: "translate(30.878)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1423",
    className: "st2",
    d: "M19.1,2.4H1.5c-0.7,0-1.2-0.6-1.2-1.2C0.4,0.5,0.9,0,1.5,0H19c0.7,0,1.2,0.6,1.2,1.2 C20.3,1.9,19.7,2.4,19.1,2.4z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_2163",
    transform: "translate(30.878 9.466)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1424",
    className: "st2",
    d: "M19.1,2.4H1.5c-0.7,0-1.2-0.5-1.2-1.2C0.3,0.5,0.9,0,1.5,0l0,0H19c0.7,0,1.2,0.5,1.2,1.2 C20.3,1.9,19.8,2.4,19.1,2.4z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_2164",
    transform: "translate(30.878 18.933)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1425",
    className: "st2",
    d: "M19.1,2.4H1.5c-0.7,0-1.2-0.6-1.2-1.2C0.4,0.5,0.9,0,1.5,0H19c0.7,0,1.2,0.6,1.2,1.2 C20.3,1.9,19.7,2.4,19.1,2.4z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_2165",
    transform: "translate(30.878 28.399)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1426",
    className: "st2",
    d: "M19.1,2.4H1.5c-0.7,0-1.2-0.6-1.2-1.2C0.4,0.5,0.9,0,1.5,0H19c0.7,0,1.2,0.6,1.2,1.2 C20.3,1.9,19.7,2.4,19.1,2.4z"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_2167",
    transform: "translate(3191.198 13064.113)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_1476",
    className: "st3",
    d: "M7.8,0L7.8,0c4.1,0,7.4,3.3,7.4,7.4v6.3c0,0.6-0.5,1.2-1.2,1.2l0,0H1.5 c-0.6,0-1.2-0.5-1.2-1.2V7.4C0.3,3.3,3.7,0,7.8,0z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_2168",
    transform: "translate(3189.978 13062.893)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1427",
    className: "st2",
    d: "M15.3,17.3H2.7c-1.3,0-2.4-1.1-2.4-2.4V8.7C0.3,3.9,4.2,0,9,0s8.7,3.9,8.7,8.7l0,0V15 C17.7,16.3,16.6,17.3,15.3,17.3z M2.8,14.9h12.4V8.7c0-3.4-2.7-6.3-6.1-6.3S2.8,5.1,2.8,8.5c0,0.1,0,0.1,0,0.2V14.9z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_2169",
    transform: "translate(3195.909 13068.513)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_8",
    className: "st1",
    cx: 3.1,
    cy: 2.7,
    r: 2.7
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_2170",
    transform: "translate(3194.688 13067.292)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1428",
    className: "st2",
    d: "M4.3,7.9c-2.2,0-4-1.8-4-4s1.8-4,4-4s4,1.8,4,4C8.2,6.1,6.5,7.9,4.3,7.9z M4.3,2.4 C3.4,2.4,2.8,3.1,2.8,4c0,0.8,0.7,1.5,1.5,1.5S5.8,4.8,5.8,4C5.8,3.1,5.1,2.4,4.3,2.4z"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLtoeUpdatePreferencesIcon);
export default __webpack_public_path__ + "static/media/ltoe-update-preferences-icon.513b3f6c9a38e99e95b8da6c8d5d4d26.svg";
export { ForwardRef as ReactComponent };